export type CompareState = {
  compareVehicleIds: string[];
};

const state: CompareState = {
  compareVehicleIds: [],
};

export default state;
